let turnstileApiPromise = null;

const hasRenderApi = api => api && typeof api.render === 'function';

const resolveTurnstileApi = resolve => {
  if (hasRenderApi(window.turnstile)) {
    resolve(window.turnstile);
  }
};

export const loadTurnstileApi = () => {
  if (hasRenderApi(window.turnstile)) {
    return Promise.resolve(window.turnstile);
  }

  if (turnstileApiPromise) {
    return turnstileApiPromise;
  }

  turnstileApiPromise = new Promise(resolve => {
    const handleTurnstileLoad = () => {
      if (!hasRenderApi(window.turnstile)) {
        return;
      }

      window.removeEventListener('turnstile-loaded', handleTurnstileLoad);
      resolve(window.turnstile);
    };

    window.addEventListener('turnstile-loaded', handleTurnstileLoad);
    resolveTurnstileApi(resolve);
  });

  return turnstileApiPromise;
};
